import React, { useState, useCallback, useEffect } from 'react';
// import TaskReminderIssue from '../components/TaskReminderIssue';
import Modal from '../../components/Modal';
import { useTranslation } from 'react-i18next';
import TaskReminderList from '../../components/TaskReminder/TaskReminderList';
import { useNavigate } from 'react-router-dom';
import NewTaskReminder from '../../components/TaskReminder/NewTaskReminder';
import { TaskReminder, User } from '../../utils/types';
import WhatsAppSender from '../../components/TaskReminder/WhatsAppSender';
import { appSettings, fetchTaskReminderList, fetchWhatsAppRecipients, sendWhatsAppMessage } from '../../utils/api';
import { toast } from 'react-toastify';



const TaskReminderPage: React.FC = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<'tasks' | 'settings'>('tasks');
    const [key, setKey] = useState(0); // Used to force re-render of TaskReminderList
    const [notifiedTaskIds, setNotifiedTaskIds] = useState<Set<number>>(new Set());

    const handleTaskCreated = useCallback(() => {
        // Increment key to force TaskReminderList to re-fetch tasks
        setKey(prevKey => prevKey + 1);
    }, []);

    //     useEffect(() => {
    //         const checkDueTasksAndNotify = async () => {

    //             console.log("Checking for due tasks...");

    //             try {
    //                 const [tasksResponse, recipients] = await Promise.all([
    //                     fetchTaskReminderList(),
    //                     fetchWhatsAppRecipients()
    //                 ]);

    //                 if (recipients.length === 0) {
    //                     console.log("No WhatsApp recipients configured. Skipping notifications.");
    //                     return;
    //                 }

    //                 const dueTasks = tasksResponse.task_reminders.filter(task =>
    //                     !task.is_completed &&
    //                     new Date(task.reminder_at) <= new Date() &&
    //                     !notifiedTaskIds.has(task.id)
    //                 );

    //                 if (dueTasks.length > 0) {
    //                     console.log(`Found ${dueTasks.length} due tasks to notify.`);
    //                     for (const task of dueTasks) {
    //                         // const message = t('taskReminder.notificationMessage', {
    //                         //     title: task.title,
    //                         //     description: task.description,
    //                         //     reminder_at: new Date(task.reminder_at).toLocaleString()
    //                         // });

    //                         const message = window.APP_CONFIG?.REACT_APP_COMPANY_NAME + ' Task Reminder\n\nDue on ' + new Date(task.reminder_at).toLocaleString()
    //  + '\n\n*' + task.title + '*\n\n' +(task.description ? `: ${task.description}` : '');


    //                         console.log(`Sending notification for "${task.title}"...`);

    //                         for (const user of recipients) {
    //                             if (user.phone && user.phone_country_code) {
    //                                 const fullPhoneNumber = `${user.phone_country_code.replace(/\D/g, '')}${user.phone.replace(/\D/g, '').replace(/^0+/, '')}`;
    //                                 await sendWhatsAppMessage(fullPhoneNumber, message);
    //                                 toast.info(`Sent reminder for "${task.title}" to ${user.name}.`);
    //                             }
    //                         }
    //                         // Mark task as notified to prevent re-sending
    //                         setNotifiedTaskIds(prev => new Set(prev).add(task.id));
    //                     }
    //                 } else {
    //                     console.log("No new due tasks to notify.");
    //                 }
    //             } catch (error) {
    //                 console.error("Error checking due tasks:", error);
    //                 toast.error("Failed to check for due task reminders.");
    //             }
    //         };

    //         // Check for due tasks every minute
    //         const intervalId = setInterval(checkDueTasksAndNotify, 10000);

    //         return () => clearInterval(intervalId); // Cleanup on unmount
    //     }, [notifiedTaskIds, t]);

    const [modal, setModal] = useState<null | 'lowtask-reminder' | 'qrscan' | 'qrgenerator' | 'multiqrpdf' | 'scanhistory' | 'reserve' | 'release' | 'receive' | 'issue' | 'adjust'>(null);

    return (
        <div className="container mx-0 p-1 pb-14 flex w-full h-screen bg-white">


            {/*  ixed top-10 left-0  grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-8 mt-8 p-2 pb-16 border-r-2 border-gray-200 bg-white shadow-lg z-10  */}
            {/* <div className="task-reminder-nav max-w-16 border-r border-gray-200 bg-white"> 

                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">TaskReminder List</h2>
                    <button onClick={() => navigate('/task-reminder-management')} className="mb-1 px-2 py-1 bg-teal-600 text-white rounded hover:bg-teal-700">Go to</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Low TaskReminder</h2><button onClick={() => setModal('lowtask-reminder')} className="mb-1 px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700">Open</button>

                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">QR Scan</h2>
                    <button onClick={() => setModal('qrscan')} className="mb-1 px-2 py-1 bg-purple-600 text-white rounded hover:bg-purple-700">Open</button>
                </div>

            </div> */}

            <div className="flex-1 w-full">
                {/* Main Content Scrollable Area */}
                <div className="w-full mx-auto md:mr-4 mb-4">
                    <div className="border-b border-gray-200">
                        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                            <button
                                onClick={() => setActiveTab('tasks')}
                                className={`${activeTab === 'tasks' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                            >
                                {t('taskReminder.newTaskReminder')}
                            </button>
                            <button
                                onClick={() => setActiveTab('settings')}
                                className={`${activeTab === 'settings' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                            >
                                Settings
                            </button>
                        </nav>
                    </div>

                    {activeTab === 'tasks' && (
                        <div className="mt-4 bg-indigo-100 p-4 rounded-xl border border-indigo-200 shadow-md">

                            <NewTaskReminder onCreated={handleTaskCreated} onClose={() => { /* Optionally handle close */ }} />

                        </div>
                    )}
                    {activeTab === 'settings' &&
                        <div className="mt-4 bg-green-200 p-4 rounded-xl border border-green-200 shadow-md">

                            <WhatsAppSender />

                        </div>
                    }

                    <TaskReminderList key={key} />

                </div>
            </div>



            <div className="task-reminder-modal-container ">

                {/* <Modal isOpen={modal === 'issue'} onClose={() => setModal(null)} title="TaskReminder Issue">
                    <TaskReminderIssue />
                </Modal>
                <Modal isOpen={modal === 'adjust'} onClose={() => setModal(null)} title="TaskReminder Adjustment">
                    <TaskReminderAdjust />
                </Modal> */}
            </div>

        </div>
    );
};

export default TaskReminderPage;
